import {useMutation} from 'react-query';
import {deleteChat} from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

interface IUseDeleteChatProps {
  onSuccess?: () => void;
}
const useDeleteChat = ({onSuccess}: IUseDeleteChatProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (guid?: string) => {
      return deleteChat(guid);
    },
    onSuccess: () => {
      onSuccess && onSuccess();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });
  return {isLoading, mutate, isSuccess};
};

export default useDeleteChat;
